export const AlertIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 8.00002C12.5523 8.00002 13 8.44773 13 9.00002V13C13 13.5523 12.5523 14 12 14C11.4478 14 11 13.5523 11 13V9.00002C11 8.44773 11.4478 8.00002 12 8.00002Z"
        fill="currentColor"
      />
      <path
        d="M12 16C11.4478 16 11 16.4477 11 17C11 17.5523 11.4478 18 12 18C12.5487 18 13.01 17.5529 13.01 17C13.01 16.4471 12.5487 16 12 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.89728C13.0312 1.89728 14.0302 2.45971 14.565 3.34139L23.0379 17.4862C23.5704 18.3916 23.574 19.5742 23.0544 20.4858C22.5332 21.4 21.5205 21.9884 20.47 22.0001L3.51904 22C2.47143 21.9885 1.46449 21.3959 0.945683 20.4858C0.426876 19.5756 0.430148 18.4072 0.954044 17.5L9.43503 3.34139C9.96985 2.45971 10.9688 1.89728 12 1.89728ZM11.1462 4.37666L2.68272 18.5058C2.31474 19.153 2.792 19.9884 3.53643 20H20.4636C21.2109 19.9884 21.6785 19.141 21.3174 18.5059L12.855 4.37865C12.4801 3.76218 11.522 3.76041 11.1462 4.37666Z"
        fill="currentColor"
      />
    </svg>
  );
};
